import { useDreamSearchFilterContext } from "@portal/app/health/_components/components/filter/DreamSearchFilterContext";
import { faFileCertificate } from "@fortawesome/pro-duotone-svg-icons/faFileCertificate";
import { useState } from "react";
import { useDreamSearchContext } from "@portal/app/health/_components/DreamSearchContext";
import { FilterPill } from "./OnlineClassesFilterPill";
import { useMixpanel } from "@portal/app/_components/hooks/useMixpanel";

export const CertificateFilterPill = () => {
  const analytics = useMixpanel();
  const { filterSettings } = useDreamSearchContext();
  const { filters, setFilters } = useDreamSearchFilterContext();
  const [isActive, setIsActive] = useState(!!filters["program_level_in"]?.includes("CERTIFICATE"));

  return filterSettings?.programLevel.includes("CERTIFICATE") ? (
    <FilterPill
      onClick={() => {
        setIsActive(!isActive);
        if (!isActive) {
          void analytics.track("Dream Search - Filter", {
            featured: "Certificate",
            filterGroup: "program_level_in",
            filterItem: "CERTIFICATE",
            filters,
          });
        }
        return setFilters(({ program_level_in, ...prevFilters }) => ({
          ...prevFilters,
          program_level_in: isActive ? [] : ["CERTIFICATE"],
        }));
      }}
      isActive={isActive}
      title="Certificate"
      iconProps={{
        icon: faFileCertificate,
        color: isActive ? "#04299E" : "#04299E70",
      }}
      data-testid="dream-search-filter-certificate"
    />
  ) : null;
};
